import EditFormGroup from "components/form/EditFormGroup";
import React, { forwardRef } from "react";

export default forwardRef(function CouponDetailForm(
  {
    data = {},
    onChange = () => {},
    onError = () => {},
    // define onchange parameter 'state', 'event', 'name-value'
    type = "state",
  },
  ref
) {
  return (
    <div className="my-2">
      <EditFormGroup
        ref={ref}
        data={data}
        onChange={onChange}
        onError={onError}
        type={type}
        layout={[
          {
            name: "code",
            label: "COUPON CODE",
            type: "text",
            size: "small",
            placeholder: "Type your code here",
            itemSize: { lg: 4, md: 4, sm: 12, xs: 12 },
            required: true,
          },
          {
            name: "start_date",
            label: "START DATE",
            type: "date",
            size: "small",
            placeholder: "Type your start date here",
            itemSize: { lg: 4, md: 4, sm: 12, xs: 12 },
            required: true,
          },
          {
            name: "end_date",
            label: "END DATE",
            type: "date",
            size: "small",
            placeholder: "Type your end date here",
            itemSize: { lg: 4, md: 4, sm: 12, xs: 12 },
            required: true,
          },
        ]}
        isLabel
        fullWidth={true}
        alignItems="flex-start"
        direction="row"
        spacing={2}
      />
    </div>
  );
});
